<template>
  <main class="container-1">

    <div class="container-header">
      <Breadcrumb :links="routesBread" />
      <!-- <h2>Notificaciones</h2> -->
      <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

      <div class="table-toolbar">

        <div class="toolbar-item">
          <label>
            Mostrar registros:
            <select
              v-model.number="pageSize"
              @change="onPageSizeChange"
            >
              <option :value="10">10</option>
              <option :value="15">15</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
            </select>
          </label>
        </div>

        <div class="toolbar-item">
          <label>
            Estado:
            <select
              id="notification-status"
              v-model="selectedStatus"
              @change="onFilterChange"
            >
              <option value="todos">Todos</option>
              <option value="active">Activas</option>
              <option value="inactive">Inactivas</option>
              <option value="expired">Expiradas</option>
            </select>
          </label>
        </div>

        <div class="toolbar-item toolbar-search">
          <label>
            Buscar:
            <input
              v-model.trim="searchQuery"
              type="text"
              placeholder="Buscar notificación..."
              @input="onSearchInput"
            />
          </label>
        </div>

        <div class="toolbar-item toolbar-clear">
          <button
            v-if="hasActiveFilters"
            type="button"
            class="filters-clear-btn"
            @click="clearFilters"
          >
            Limpiar filtros
          </button>
        </div>

      </div>
      <div
        v-if="notificationsError"
        class="list-message list-message-error"
      >
        {{ notificationsError }}
      </div>

      <div
        v-if="loadingNotifications"
        class="list-message"
      >
        Cargando notificaciones...
      </div>
      <div class="table-wrapper">
        <table class="notifications-table">

          <thead>
            <tr>
              <th>#</th>
              <th class="sortable" @click="onSort('title')">
                Título <font-awesome-icon :icon="getSortIcon('title')" />
              </th>
              <th>Mensaje</th>
              <th>Destinatarios</th>
              <th>Correo</th>
              <th class="sortable" @click="onSort('created_at')">
                Fecha creación <font-awesome-icon :icon="getSortIcon('created_at')" />
              </th>
              <th>Expiración</th>
              <th class="sortable" @click="onSort('active')">
                Estado <font-awesome-icon :icon="getSortIcon('active')" />
              </th>
              <th>Acción</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(notification, index) in notifications"
              :key="notification.id"
              :class="{
                'row-inactive': !isNotificationEnabled(notification)
              }"
            >
              <td>
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </td>

              <td class="notification-title">
                {{ notification.title }}
              </td>

              <td class="notification-message">
                {{ truncateMessage(notification.message) }}
              </td>

              <td>
                <button
                  type="button"
                  class="recipient-link"
                  @click="openRecipientsModal(notification)"
                >
                  {{ recipientSummary(notification) }}
                </button>
              </td>

              <td>
                <span
                  class="state-label"
                  :class="booleanStateClass(notification.send_email)"
                >
                  {{ notification.send_email ? 'Sí' : 'No' }}
                </span>
              </td>

              <td>
                {{ formatDate(notification.created_at) }}
              </td>

              <td>
                {{ formatExpiration(notification.expires_at) }}
              </td>

              <td>
                <span
                  class="state-label"
                  :class="notificationStateClass(notification)"
                >
                  <span class="state-dot"></span>
                  {{ notificationStateText(notification) }}
                </span>
              </td>

              <td class="action-cell">
                <div class="action-cell__buttons">

                  <button
                    type="button"
                    class="btn-action btn-ver"
                    @click="openRecipientsModal(notification)"
                  >
                    <font-awesome-icon icon="eye" /> Ver
                  </button>

                  <router-link
                    :to="{
                      name: 'UsersNotificationsEdit',
                      params: {
                        idNotification: notification.id
                      }
                    }"
                    class="btn-action btn-edit"
                  >
                    Editar
                  </router-link>

                  <button
                    type="button"
                    class="btn-action"
                    :class="
                      notification.active
                        ? 'btn-deactivate'
                        : 'btn-activate'
                    "
                    :disabled="
                      isExpired(notification) ||
                      isToggling(notification.id)
                    "
                    :title="
                      isExpired(notification)
                        ? 'Las notificaciones expiradas no pueden activarse desde el listado'
                        : ''
                    "
                    @click="toggleNotification(notification)"
                  >
                    {{
                      isToggling(notification.id)
                        ? 'Actualizando...'
                        : notification.active
                          ? 'Desactivar'
                          : 'Activar'
                    }}
                  </button>

                  <button
                    type="button"
                    class="btn-action btn-delete"
                    @click="openDeleteModal(notification)"
                  >
                    Eliminar
                  </button>

                </div>
              </td>
                          </tr>

              <tr
                v-if="
                  !loadingNotifications &&
                  notifications.length === 0
                "
              >
              <td
                colspan="9"
                class="empty-message"
              >
                No hay notificaciones para mostrar.
              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <Pagination
        v-show="totalPages !== 0"
        :totalPages="totalPages"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @pagechanged="pageChangedClick"
      />

    </div>

    <!-- <SideNav
      class="container-sidenav"
      :links="routesNav"
    /> -->

    <!-- Modal de destinatarios -->
    <div
      v-if="showRecipientsModal"
      class="modal-backdrop"
      @click.self="closeRecipientsModal"
    >
      <section
        class="modal-window"
        role="dialog"
        aria-modal="true"
      >
        <header class="modal-header">
          <div>
            <span class="modal-category">
              Destinatarios
            </span>

            <h3>
              {{ selectedNotification
                ? selectedNotification.title
                : ''
              }}
            </h3>
          </div>

          <button
            type="button"
            class="modal-close"
            aria-label="Cerrar"
            @click="closeRecipientsModal"
          >
            ×
          </button>
        </header>

        <div class="modal-body">

          <div
            v-if="
              selectedNotification &&
              selectedNotification.all_users
            "
            class="all-users-info"
          >
            <strong>Todos los usuarios</strong>

            <p>
              Esta notificación está dirigida a todos los usuarios
              registrados en el sistema.
            </p>
          </div>

          <template v-else>

            <div class="recipients-summary">
              {{ recipientUsers.length }}
              {{ recipientUsers.length === 1
                ? 'destinatario'
                : 'destinatarios'
              }}
            </div>

            <div class="recipient-table-wrapper">
              <table class="recipient-table">

                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Grupo</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="user in recipientUsers"
                    :key="user.id"
                  >
                    <td>
                      {{ user.firstname }}
                      {{ user.lastname }}
                    </td>

                    <td>
                      {{ user.username || 'Sin información' }}
                    </td>

                    <td>
                      {{ user.group_name || 'Sin información' }}
                    </td>
                  </tr>

                  <tr v-if="recipientUsers.length === 0">
                    <td
                      colspan="3"
                      class="empty-message"
                    >
                      No se encontraron destinatarios.
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>

          </template>

        </div>

        <footer class="modal-footer">
          <button
            type="button"
            class="modal-button"
            @click="closeRecipientsModal"
          >
            Cerrar
          </button>
        </footer>
      </section>
    </div>

    <!-- Modal para eliminar -->
    <div
      v-if="showDeleteModal"
      class="modal-backdrop"
      @click.self="closeDeleteModal"
    >
      <section
        class="modal-window modal-confirm"
        role="dialog"
        aria-modal="true"
      >
        <header class="modal-header">
          <div>
            <span class="modal-category">
              Confirmación
            </span>

            <h3>Eliminar notificación</h3>
          </div>

          <button
            type="button"
            class="modal-close"
            aria-label="Cerrar"
            @click="closeDeleteModal"
          >
            ×
          </button>
        </header>

        <div class="modal-body">
          <p>
            ¿Estás seguro de que deseas eliminar la notificación
            <strong>
              {{ notificationToDelete
                ? notificationToDelete.title
                : ''
              }}
            </strong>?
          </p>

          <p class="delete-warning">
            Esta acción no se puede deshacer.
          </p>
        </div>

        <footer class="modal-footer">

          <button
            type="button"
            class="modal-button"
            @click="closeDeleteModal"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="modal-button modal-button-delete"
            @click="confirmDelete"
          >
            Eliminar
          </button>

        </footer>
      </section>
    </div>

  </main>
</template>

<script>
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import { restNotification } from '@/components/mixin/restNotification.js'
import { restGroup } from '@/components/mixin/restGroup.js'
export default {
  name: 'Notifications',
    mixins: [
    restNotification,
    restGroup,
  ],
  components: {
    SideNav,
    Breadcrumb,
    Pagination,
    TabNav
  },
  data() {
    return {
      notifications: [],
      groupsWithUsers: [],

      loadingNotifications: false,
      notificationsError: '',

      selectedStatus: 'todos',
      searchQuery: '',
      sortKey: '',
      sortOrder: 'asc',

      currentPage: 1,
      pageSize: 10,

      totalPages: 0,
      totalNotifications: 0,

      searchTimer: null,
      togglingNotificationIDs: [],

      selectedNotification: null,
      notificationToDelete: null,

      showRecipientsModal: false,
      showDeleteModal: false
    }
  },

  computed: {
    hasActiveFilters() {
      return (
        this.searchQuery !== '' ||
        this.selectedStatus !== 'todos' ||
        this.sortKey !== ''
      )
    },

    routesNav() {
      return [
        {
          name: 'Notificaciones'
        },
        {
          name: 'Nueva notificación',
          path: '/usuarios/notificaciones/nueva-notificacion'
        }
      ]
    },

    routesBread() {
      return [
        {
          name: 'Usuarios',
          path: '/usuarios'
        },
        {
          name: 'Notificaciones'
        }
      ]
    },







    allUsersList() {
      return this.groupsWithUsers.reduce(
        (users, group) => {
          const groupUsers = (group.users || []).map(
            (user) => ({
              ...user,
              group_name: group.name
            })
          )

          return users.concat(groupUsers)
        },
        []
      )
    },

    recipientUsers() {
      if (
        !this.selectedNotification ||
        this.selectedNotification.all_users
      ) {
        return []
      }

      const userIDs =
        this.selectedNotification.user_ids || []

      return userIDs.map((userID) => {
        const user = this.allUsersList.find(
          (item) =>
            String(item.id) === String(userID)
        )

        if (user) {
          return user
        }

        return {  
          id: userID,
          firstname: 'Usuario',
          lastname: 'no disponible',
          username: '',
          group_name: ''
        }
      })
    }
  },

  created() {
    if (!this.$store.getters.getPermissions.users) {
      this.$router.push('/pagina-no-encontrada')
    }
  },

  mounted() {
    this.loadNotifications()
    this.loadGroupsWithUsers()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },

  methods: {
    async loadGroupsWithUsers() {
      try {
        const response = await this.getGroupsWithUsers()

        this.groupsWithUsers = (
          response.data || []
        ).map((group) => ({
          ...group,
          id: String(group.id),

          users: (group.users || []).map((user) => ({
            ...user,
            id: String(user.id)
          }))
        }))
      } catch (error) {
        console.error(error)

        this.notificationsError =
          error.response?.data?.message ||
          'No fue posible cargar los destinatarios.'
      }
    },
    pageChangedClick(page) {
      if (page === this.currentPage) return

      this.currentPage = page
      this.loadNotifications()
    },

    onPageSizeChange() {
      this.currentPage = 1
      this.loadNotifications()
    },

    onFilterChange() {
      clearTimeout(this.searchTimer)

      this.currentPage = 1
      this.loadNotifications()
    },

    onSearchInput() {
      clearTimeout(this.searchTimer)

      this.searchTimer = setTimeout(() => {
        this.currentPage = 1
        this.loadNotifications()
      }, 400)
    },

    clearFilters() {
      clearTimeout(this.searchTimer)

      this.searchQuery = ''
      this.selectedStatus = 'todos'
      this.sortKey = ''
      this.sortOrder = 'asc'
      this.currentPage = 1

      this.loadNotifications()
    },

    onSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'asc'
      }

      this.currentPage = 1
      this.loadNotifications()
    },

    getSortIcon(key) {
      if (this.sortKey !== key) return 'sort'
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
    },
  async loadNotifications() {
    this.loadingNotifications = true
    this.notificationsError = ''

    await this.getNotificationsPages(
      this.currentPage,
      this.searchQuery,
      this.pageSize,
      this.selectedStatus,
      this.sortKey,
      this.sortOrder
    )

    this.loadingNotifications = false
  }, 



    truncateMessage(message) {
      if (!message) {
        return ''
      }

      if (message.length <= 75) {
        return message
      }

      return `${message.substring(0, 75)}...`
    },

    formatDate(value) {
      if (!value) {
        return 'Sin registro'
      }

      return new Intl.DateTimeFormat('es-CL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(new Date(value))
    },

    formatExpiration(value) {
      if (!value) {
        return 'Sin expiración'
      }

      return this.formatDate(value)
    },

    isExpired(notification) {
      if (!notification.expires_at) {
        return false
      }

      return (
        new Date(notification.expires_at) <= new Date()
      )
    },

    isNotificationEnabled(notification) {
      return (
        notification.active &&
        !this.isExpired(notification)
      )
    },

    notificationStateText(notification) {
      if (this.isExpired(notification)) {
        return 'Expirada'
      }

      return notification.active
        ? 'Activa'
        : 'Inactiva'
    },

    notificationStateClass(notification) {
      return this.isNotificationEnabled(notification)
        ? 'state-enabled'
        : 'state-disabled'
    },

    booleanStateClass(value) {
      return value
        ? 'state-enabled'
        : 'state-disabled'
    },

    recipientSummary(notification) {
      if (notification.all_users) {
        return 'Todos los usuarios'
      }

      const count =
        notification.user_ids
          ? notification.user_ids.length
          : 0

      return count === 1
        ? '1 usuario'
        : `${count} usuarios`
    },

    openRecipientsModal(notification) {
      this.selectedNotification = notification
      this.showRecipientsModal = true
    },

    closeRecipientsModal() {
      this.selectedNotification = null
      this.showRecipientsModal = false
    },

async toggleNotification(notification) {
  if (
    this.isExpired(notification) ||
    this.isToggling(notification.id)
  ) {
    return
  }

  const newStatus = !notification.active

  this.togglingNotificationIDs.push(
    notification.id
  )

  try {
    const response =
      await this.patchNotificationStatus(
        notification.id,
        newStatus
      )

    notification.active =
      response.data.active
  } catch (error) {
    console.log(error)

    this.notificationsError =
      error.response &&
      error.response.data
        ? error.response.data.message
        : 'No fue posible cambiar el estado.'
  } finally {
    this.togglingNotificationIDs =
      this.togglingNotificationIDs.filter(
        (id) => id !== notification.id
      )
  }
},

    isToggling(notificationID) {
      return this.togglingNotificationIDs.includes(
        notificationID
      )
    },
    openDeleteModal(notification) {
      this.notificationToDelete = notification
      this.showDeleteModal = true
    },

    closeDeleteModal() {
      this.notificationToDelete = null
      this.showDeleteModal = false
    },

    async confirmDelete() {
      if (!this.notificationToDelete) {
        return
      }

      const notificationID =
        this.notificationToDelete.id

      /*
      * Si eliminamos el único elemento de una página
      * distinta a la primera, volvemos a la anterior.
      */
      const shouldGoPreviousPage =
        this.notifications.length === 1 &&
        this.currentPage > 1

      try {
        await this.deleteNotification(notificationID)

        if (shouldGoPreviousPage) {
          this.currentPage--
        }

        this.closeDeleteModal()

        await this.loadNotifications()
      } catch (error) {
        console.error(error)

        this.notificationsError =
          error.response?.data?.message ||
          'No fue posible eliminar la notificación.'

        this.closeDeleteModal()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.table-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 2em;
  margin-bottom: 1.2em;
}

.toolbar-item {
  display: flex;
  flex-direction: column;
}

.toolbar-item label {
  display: flex;
  flex-direction: column;
  gap: 0.35em;
  color: var(--color-navy);
  font-size: 0.82em;
  font-weight: 600;
}

.toolbar-item select,
.toolbar-item input {
  min-width: 180px;
  height: 34px;
  padding: 0.35em 0.6em;
  border: 1px solid var(--color-fog);
  border-radius: 4px;
  background: var(--color-white);
  color: var(--color-graphite);
  font-family: inherit;
}

.toolbar-search {
  flex: 1;
  max-width: 340px;
  margin-left: auto;
}

.toolbar-search input {
  width: 100%;
}

.toolbar-item select:focus,
.toolbar-item input:focus {
  outline: 2px solid var(--color-steel);
  outline-offset: 1px;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.notifications-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

.notifications-table th,
.notifications-table td {
  padding: 0.7em 0.8em;
  border-bottom: 1px solid var(--color-fog);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.notifications-table thead th {
  background: var(--color-navy);
  color: var(--color-white);
  white-space: nowrap;
  font-weight: 600;
}

.notifications-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.notifications-table th.sortable:hover {
  background: var(--color-steel);
}

.notifications-table tbody tr:hover {
  background: var(--color-mist);
}

.notifications-table tbody tr.row-inactive {
  color: var(--color-ghost);
}

.notification-title {
  min-width: 160px;
  color: var(--color-navy);
  font-weight: 600;
}

.row-inactive .notification-title {
  color: var(--color-ghost);
}

.notification-message {
  min-width: 230px;
  max-width: 350px;
}

.recipient-link {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-steel);
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.recipient-link:hover {
  color: var(--color-navy);
}

.state-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.3em 0.65em;
  border: 1px solid;
  border-radius: 4px;
  font-size: 0.78em;
  font-weight: 600;
  white-space: nowrap;
}

.state-enabled {
  border-color: var(--color-steel);
  background: var(--color-white);
  color: var(--color-steel);
}

.state-disabled {
  border-color: var(--color-fog);
  background: var(--color-mist);
  color: var(--color-ghost);
}

.state-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.action-cell {
  white-space: nowrap;
  vertical-align: middle;
}

.action-cell__buttons {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.4em;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.2em 0.55em;
  border: none;
  border-radius: 3px;
  font-family: inherit;
  font-size: 0.82em;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: opacity 0.12s;
}

.btn-action:hover {
  opacity: 0.8;
  text-decoration: none;
}

.btn-ver {
  background: #e8f4fd;
  color: var(--color-navy);
}

.btn-edit {
  background: #fef9e7;
  color: #7d6608;
}

.btn-activate {
  background: #eaf7ef;
  color: #1e8449;
}

.btn-deactivate {
  background: #f2f4f4;
  color: #566573;
}

.btn-delete {
  background: #fdf2f2;
  color: #922b21;
}
.empty-message {
  padding: 2em !important;
  color: var(--color-ghost);
  text-align: center !important;
}

/* Modales */

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2em;
  background: color-mix(
    in srgb,
    var(--color-dark) 60%,
    transparent
  );
}

.modal-window {
  width: 100%;
  max-width: 760px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--color-fog);
  border-radius: 6px;
  background: var(--color-white);
}

.modal-confirm {
  max-width: 520px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1em;
  padding: 1em 1.3em;
  border-bottom: 1px solid var(--color-fog);
  background: var(--color-navy);
  color: var(--color-white);
}

.modal-header h3 {
  margin: 0.15em 0 0;
  color: var(--color-white);
  font-size: 1.1em;
}

.modal-category {
  color: var(--color-orange-light);
  font-size: 0.72em;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.modal-close {
  width: 29px;
  height: 29px;
  border: 1px solid var(--color-steel);
  border-radius: 4px;
  background: transparent;
  color: var(--color-white);
  font-size: 1.25em;
  cursor: pointer;
}

.modal-close:hover {
  border-color: var(--color-orange);
  color: var(--color-orange);
}

.modal-body {
  padding: 1.3em;
  overflow-y: auto;
  color: var(--color-graphite);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7em;
  padding: 0.9em 1.3em;
  border-top: 1px solid var(--color-fog);
  background: var(--color-mist);
}

.modal-button {
  padding: 0.5em 1em;
  border: 1px solid var(--color-steel);
  border-radius: 4px;
  background: var(--color-white);
  color: var(--color-steel);
  font-family: inherit;
  font-size: 0.82em;
  font-weight: 600;
  cursor: pointer;
}

.modal-button:hover {
  background: var(--color-steel);
  color: var(--color-white);
}

.modal-button-delete {
  border-color: var(--color-danger);
  color: var(--color-danger);
}

.modal-button-delete:hover {
  background: var(--color-danger);
  color: var(--color-white);
}

.all-users-info {
  padding: 1em;
  border-left: 4px solid var(--color-steel);
  background: var(--color-mist);
}

.all-users-info strong {
  color: var(--color-navy);
}

.all-users-info p {
  margin: 0.35em 0 0;
  font-size: 0.86em;
}

.recipients-summary {
  margin-bottom: 0.8em;
  color: var(--color-steel);
  font-size: 0.82em;
  font-weight: 600;
}

.recipient-table-wrapper {
  overflow-x: auto;
}

.recipient-table {
  width: 100%;
  border-collapse: collapse;
}

.recipient-table th,
.recipient-table td {
  padding: 0.7em;
  border-bottom: 1px solid var(--color-fog);
  text-align: left;
  font-size: 0.82em;
}

.recipient-table th {
  background: var(--color-mist);
  color: var(--color-navy);
}

.delete-warning {
  padding: 0.75em;
  border-left: 3px solid var(--color-danger);
  background: var(--color-mist);
  color: var(--color-danger);
  font-size: 0.85em;
}
.list-message {
  margin-bottom: 1em;
  padding: 0.8em 1em;
  border: 1px solid var(--color-steel);
  border-radius: 4px;
  background: var(--color-mist);
  color: var(--color-steel);
  font-size: 0.84em;
}

.list-message-error {
  border-color: var(--color-danger);
  color: var(--color-danger);
}

.btn-action:disabled {
  color: var(--color-ghost);
  opacity: 0.45;
  cursor: not-allowed;
}

.btn-action:disabled:hover {
  opacity: 0.45;
}
@media (max-width: 1000px) {
  .notifications-table {
    min-width: 1100px;
  }

  .table-toolbar {
    flex-wrap: wrap;
  }

  .toolbar-search {
    margin-left: 0;
  }
}

@media (max-width: 640px) {
  .table-toolbar {
    align-items: stretch;
  }

  .toolbar-item,
  .toolbar-item select,
  .toolbar-item input,
  .toolbar-search {
    width: 100%;
    max-width: none;
  }

  .modal-backdrop {
    align-items: flex-start;
    padding: 1em;
  }
}
</style>
